import { render, staticRenderFns } from "./NbQuizAdminNavigationDrawer.vue?vue&type=template&id=2e31cfca"
import script from "./NbQuizAdminNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NbQuizAdminNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports